import React, { useState } from "react";
import illustrationImg from "../assets/ChatGPT Image May 19, 2025, 11_37_00 AM.png";
import "./Kontakt.css";
import { Footer } from "./Footer";

export function Kontakt() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    city: "",
    phone: "",
    message: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = `Kontaktim nga ${formData.name}`;
    const body =
      `Emri dhe Mbiemri: ${formData.name}\n` +
      `Email: ${formData.email}\n` +
      `Qyteti: ${formData.city}\n` +
      `Numri i Kontaktit: ${formData.phone}\n` +
      `Mesazhi: ${formData.message}`;
    window.location.href =
      `mailto:info@foxacademy.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <>
      <section className="upa-contact-main">
        <div className="upa-contact-left">
          <div className="upa-hero-text">
            <span className="upa-black">A PO</span>
            <span className="upa-yellow">FILLOJM KURSIN N FOX ?</span>
          </div>
          <img
            src={illustrationImg}
            className="upa-illustration"
            alt="Hero"
          />
        </div>
        <div className="upa-contact-right">
          <form className="upa-form" onSubmit={handleSubmit}>
            <h1>Na Kontakto</h1>
            <p>
              Je i interesuar për bashkëpunim?<br />
              Plotëso formularin dhe ne do të të kontaktojmë sa më shpejt!
            </p>
            <div className="upa-form-row">
              <input
                type="text"
                name="name"
                placeholder="Emri dhe Mbiemri"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="upa-form-row">
              <input
                type="text"
                name="city"
                placeholder="Qyteti"
                value={formData.city}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Numri i Kontaktit"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <textarea
              name="message"
              placeholder="Mesazhi yt"
              value={formData.message}
              onChange={handleChange}
              required
              rows={6}
            />
            <button type="submit">Dërgo</button>
          </form>
        </div>
      </section>
      <section className="upa-map-section">
        <h2>Na Gjeni në Hartë</h2>
        <div className="upa-map-wrap">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2941.082624532888!2d21.15823491544049!3d42.66330767916706!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13549ec2205f4b3d%3A0x2e1e9f2e8d02b6cf!2sUPA%20(United%20Pixels%20Academy)!5e0!3m2!1sen!2s!4v1684331531234!5m2!1sen!2s"
            width="100%"
            height="420"
            style={{ border: 0, borderRadius: "18px", boxShadow: "0 4px 32px #0001" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Fox Academy Map"
          />
        </div>
      </section>
      <Footer />
    </>
  );
}
